import './FindInStoreModal.scss'
import { GrFormClose } from 'react-icons/gr'
import { useTranslation } from 'react-i18next';
import SearchBar from './SearchBar';
import SearchResult from './SearchResult';
import FrameCard from './FrameCard'
import StoreInfo from './StoreInfo';
import { useDispatch, useSelector } from 'react-redux';
import { changeLocation, setClickedStore } from '../redux/reducers/popupDataSlice';
import { getDefaultMapLink } from '../utils/Utils';

const FindInStoreModal = (props) => {

    const { t } = useTranslation();

    const showSearchResult = useSelector(state => state.popupData.physicalStores);
    const inputLocation = useSelector(state => state.popupData.inputLocation);
    const clickedStore = useSelector(state => state.popupData.clickedStore);
    const selectedStore = useSelector(state => state.popupData.selectedStore);
    const storeDispatcher = useDispatch();

    const onChangeLocation = () => {
        const mapLink = getDefaultMapLink(props.config.data.storeId);
        storeDispatcher(changeLocation(mapLink));
    }

    return (
        <div className='modal-container'>
            <div className='modal-overlay' onClick={props.onClose}></div>
            <div className='modal'>
                <div className='modal-header container-fluid'>
                    <div className='row'>
                        <div className='align-right'>
                            <button className='close-popup-btn' onClick={props.onClose}>
                                <GrFormClose size={30} />
                            </button>
                        </div>
                    </div>
                </div>
                <div className={'modal-left' + (!inputLocation || !clickedStore ? ' show-modal-mobile' : '') + (inputLocation ? ' see-result' : '')}>
                    <div className='row title-container'>
                        <div className='title'>
                            <div className="title-icon">
                                <svg>
                                    <use xlinkHref='#navigations' />
                                </svg>
                            </div>
                            <span className="title-name">{props.config.data.frame.isStellaProduct ? t('find-button-stella') : t('find-button')}</span>
                        </div>
                    </div>
                    <div className='container'>
                        <div className='row modal-frame-card'>
                            <div className='col-12 m-bottom'><FrameCard config={props.config} /></div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>{!showSearchResult && < SearchBar config={props.config}/>} </div>
                        </div>
                        <div className='row search-result-container'>
                            <div className='col-12 search-result'>{showSearchResult && <SearchResult onChangeLocation={onChangeLocation} />}</div>
                        </div>
                    </div>
                </div>
                <div className={'modal-right' + (!inputLocation ? ' only-map' : '') + (!inputLocation || clickedStore ? ' show-modal-mobile' : '')}>
                    <div className='container modal-right-inner'>
                        <div className='row'>
                            {selectedStore && (
                                <div className={'col-11 arrow-mobile' + (clickedStore ? ' title-mobile' : '')}>
                                    <svg className="arrow-left"  onClick={() => storeDispatcher(setClickedStore(null))}>
                                        <use xlinkHref='#bold-arrow' />
                                    </svg>
                                    <span className="store-name-title">
                                        {selectedStore.Description[0].displayStoreName.toLowerCase()}
                                    </span>
                                </div>
                            )}
                            <div className='col-12'><StoreInfo config={props.config}/></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}


export default FindInStoreModal;
